export const freezerBorder = 4;
